import React, { useEffect, useState } from 'react';
import { useApptekster } from '../contexts/ApptekstContext';
import { GyldigSkiltForKjoretoy } from '../utils/api';
import { UseApiProps } from '../hooks/useApi';
import { SVVSpinner } from '@komponentkassen/svv-spinner';
import { useSkiltbestillingState } from '../page/skiltbestilling/Skiltbestilling';
import { useFeil } from '../hooks/useFeil';
import { PakrevdFelt } from './PakrevdFelt';
import { SVVSearchField } from '@komponentkassen/svv-form';

export type HentKjoretoySkjemaSkjemaData = { sokefelt: string };

type HentKjoretoySkjemaProps = {
    api: UseApiProps<GyldigSkiltForKjoretoy>;
};
export const HentKjoretoySkjema: React.FC<HentKjoretoySkjemaProps> = ({
    api: { hent, laster, data, timestamp },
}) => {
    const t = useApptekster();
    const [feilmelding, setFeilmelding] = useState('');
    const rettighetId = useSkiltbestillingState((state) => state.rettighetId);

    const { tilFeilmelding } = useFeil({
        fantIngenKjoretoy:
            'personlig-kjennemerke.knytning.sjekk.merknad.fant-ikke-kjoretoy',
        ikkeEierAvKjoretoy:
            'personlig-kjennemerke.knytning.sjekk.merknad.ikke-registrert-eier',
        kjoretoyHarMedeier:
            'personlig-kjennemerke.knytning.sjekk.merknad.har-medeier',
        kjoretoyErVraket: 'personlig-kjennemerke.knytning.sjekk.merknad.vraket',
        kjoretoyErUtfort: 'personlig-kjennemerke.knytning.sjekk.merknad.utfort',
        kjoretoyStotterIkkePersonligKjennemerke:
            'personlig-kjennemerke.bestill.validering.stotter-ikke-pk',
        skiltForKjoretoyPasserIkkeTegnkombinasjon:
            'personlig-kjennemerke.bestill.validering.passer-ikke',
        default: 'personlig-kjennemerke.delt.validering.default',
    });

    useEffect(() => {
        if (timestamp && data?.ok === false) {
            setFeilmelding(tilFeilmelding(data.feilkode));
        }
    }, [data, tilFeilmelding, setFeilmelding, timestamp]);

    return (
        <div className="spacing-bottom--medium">
            <PakrevdFelt className="spacing-bottom--small" />
            <SVVSearchField
                id={'sok-skilt-'}
                maxLength={8}
                label={t('personlig-kjennemerke.felles.kjoretoy.label')}
                placeholder={t(
                    'personlig-kjennemerke.felles.kjoretoy.placeholder',
                )}
                errorMessage={feilmelding}
                onSearch={(f) => {
                    if (f.length === 0) {
                        setFeilmelding(
                            t(
                                'personlig-kjennemerke.bestill.kjoretoy.validering.paakrevd',
                            ),
                        );
                    } else if (!f.match(/^[a-zA-Z0-9 ]*$/)) {
                        setFeilmelding(
                            t(
                                'personlig-kjennemerke.bestill.kjoretoy.validering.ugyldig',
                            ),
                        );
                    } else {
                        setFeilmelding('');
                        return hent(rettighetId, f.toUpperCase());
                    }
                }}
                required
            />
            <div aria-live="polite">
                {laster && (
                    <SVVSpinner size="small" centered={false}>
                        {t('personlig-kjennemerke.delt.laster')}
                    </SVVSpinner>
                )}
            </div>
        </div>
    );
};
